import { render } from "./hcpMm.vue?vue&type=template&id=fe6c3622"
import script from "./hcpMm.vue?vue&type=script&lang=js"
export * from "./hcpMm.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\humanbrainview\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__